import React from 'react';
import { Box, Container, Grid, Typography, Link, Divider, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom'; // Import Link from React Router
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

// Theme Colors
const themeColors = {
  grey: '#686978',
  lightGrey: '#F5F5F5',
  black: '#000000',
};

// Footer Component
const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: themeColors.lightGrey,
        padding: '40px 20px',
        color: themeColors.black,
      }}
    >
      <Container maxWidth="lg">
        {/* Top Section */}
        <Grid container spacing={4}>
          {/* About Us */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '12px' }}>
              About Us
            </Typography>
            <Typography variant="body2" sx={{ color: themeColors.grey }}>
              AIDNix is your trusted healthcare platform for lab tests, medicines, and doctor consultations.
            </Typography>
            <Link
              component={RouterLink}
              to="/about-us"
              underline="hover"
              sx={{ display: 'block', marginTop: '8px', color: themeColors.black, fontWeight: 'bold' }}
            >
              Learn More
            </Link>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '12px' }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Link component={RouterLink} to="/" underline="hover" sx={{ color: themeColors.grey }}>
                Home
              </Link>
              <Link component={RouterLink} to="/lab-tests" underline="hover" sx={{ color: themeColors.grey }}>
                Lab Tests
              </Link>
              <Link component={RouterLink} to="/medicines" underline="hover" sx={{ color: themeColors.grey }}>
                Medicines
              </Link>
              <Link component={RouterLink} to="/doctors" underline="hover" sx={{ color: themeColors.grey }}>
                Doctors
              </Link>
            </Box>
          </Grid>

          {/* Support */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '12px' }}>
              Help & Support
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Link component={RouterLink} to="/faqs" underline="hover" sx={{ color: themeColors.grey }}>
                FAQs
              </Link>
              <Link component={RouterLink} to="/contact-us" underline="hover" sx={{ color: themeColors.grey }}>
                Contact Us
              </Link>
              <Link component={RouterLink} to="/privacy-policy" underline="hover" sx={{ color: themeColors.grey }}>
                Privacy Policy
              </Link>
              <Link component={RouterLink} to="/terms-and-conditions" underline="hover" sx={{ color: themeColors.grey }}>
                Terms & Conditions
              </Link>
            </Box>
          </Grid>

          {/* Social Media */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '12px' }}>
              Follow Us
            </Typography>
            <Box sx={{ display: 'flex', gap: '12px' }}>
              <IconButton aria-label="Facebook" href="#" sx={{ color: themeColors.black }}>
                <FacebookIcon />
              </IconButton>
              <IconButton aria-label="Instagram" href="#" sx={{ color: themeColors.black }}>
                <InstagramIcon />
              </IconButton>
              <IconButton aria-label="Twitter" href="#" sx={{ color: themeColors.black }}>
                <TwitterIcon />
              </IconButton>
              <IconButton aria-label="LinkedIn" href="#" sx={{ color: themeColors.black }}>
                <LinkedInIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* Divider */}
        <Divider sx={{ marginY: '20px', backgroundColor: themeColors.grey, opacity: 0.4 }} />

        {/* Bottom Section */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
          }}
        >
          <Typography variant="body2" sx={{ color: themeColors.grey }}>
            &copy; {new Date().getFullYear()} AIDNix. All Rights Reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: '16px' }}>
            <Link component={RouterLink} to="/privacy-policy" underline="hover" sx={{ color: themeColors.grey }}>
              Privacy Policy
            </Link>
            <Link component={RouterLink} to="/terms-and-conditions" underline="hover" sx={{ color: themeColors.grey }}>
              Terms & Conditions
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;